import responsiveRing from './geometry';
var preRenderResponsive = [{ name: 'responsiveRing', method: responsiveRing }];
var afterRenderResponsive = [];
export default {
    preRender: preRenderResponsive,
};
//# sourceMappingURL=index.js.map